import { COLORS } from '@btime/constants'
import React from 'react'

import Text from './Text'

const styles = {
  root: {
    background: COLORS.white,
    padding: 0,
    width: '100%'
  },

  table: {
    pageBreakAfter: 'always',
    width: '100%'
  }
}

const Page = ({ children, header, footer }) => (
  <div id="pdfPage" wrap size="A4" style={styles.root}>
    <table style={styles.table}>
      {header && (
        <thead style={{ display: 'table-header-group' }}>
          <tr>
            <th>{header}</th>
          </tr>
        </thead>
      )}

      {footer && (
        <tfoot style={{ display: 'table-footer-group' }}>
          <tr>
            <td>{footer}</td>
          </tr>
        </tfoot>
      )}

      <tbody>
        <tr>
          <td>
            <div>{children}</div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
)

export default Page
